import React from "react";
import {toAbsoluteUrl} from "../../../_metronic/_helpers"
// import Loader from "react-loader-spinner";

function Form({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  touched,
  values,
  handleClean
}) {

  const isValid = values.isValid;

  return (
    <>

{/* <div className="loadingPanel">
    <Loader
        type="TailSpin"
        color="#00BFFF"
        height={100}
        width={100}
        visible={true}
      />
</div> */}
   
    <div>
      <form className="formarea" onSubmit={handleSubmit} autoComplete="off">
        <div className="form-group">
          <label className="col-md-12" htmlFor="iban">
            IBAN *
            <input
              type="text"
              className="form-control"
              id="iban"
              placeholder="Enter IBAN"
              value={values.iban}
              onChange={handleChange}
              onBlur={handleBlur}
              name="iban"
              maxLength="27"
              required
            />
            {touched.iban && errors.iban}
          </label>
        </div>
        <div className="form-group">
          <label className="col-md-12" htmlFor="cf">
            Codice Fiscale
            <input
              type="text"
              className="form-control"
              id="cf"
              placeholder="Enter Fiscal Code"
              value={values.cf}
              onChange={handleChange}
              onBlur={handleBlur}
              name="cf"
              maxLength="16"
              //required
            />
            {touched.cf && errors.cf}
          </label>
        </div>
        <div className="form-group">
          <label className="col-md-12" htmlFor="piva">
            P.IVA
            <input
              type="text"
              className="form-control"
              id="piva"
              placeholder="Enter P.IVA"
              value={values.piva}
              onChange={handleChange}
              onBlur={handleBlur}
              name="piva"
              maxLength="13"
              //required
            />
            {touched.piva && errors.piva}
          </label>
        </div>
        {/* <div className="form-group">
          <label htmlFor="age">
            Age *
            <input
              type="number"
              className="form-control"
              id="age"
              placeholder="Enter age"
              value={values.age || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              name="age"
              min="0"
              required
            />
            {touched.age && errors.age}
          </label>
        </div> */}
        <div className="form-group">
          <div className="row">
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary">
                Verifica
              </button>
            </div>
            <div className="col-md-5">
              <input type="button" value="Svuota campi" className="btn btn-primary" onClick={handleClean} />
                
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
           
                <div class="col-md-2" style={{ alignSelf: "center" }}>
                  {/* <label className="col-md-3" htmlFor="isValid"> */}
                  <label htmlFor="isValid">
                    Esito: {'    '}

                    {isValid === '' ? (<div/>):(
                      isValid==="OK" ? (
                        // <img alt="ok"  height="50" src={toAbsoluteUrl("/media/png/markers/OK.png")}/>
                        <img alt="ok"  height="50" src={toAbsoluteUrl("/media/svg/icons/Layout/Green_check.svg")}/>
                      ):(
                        // <img alt="ko"  height="50" src={toAbsoluteUrl("/media/png/markers/KO.png")}/>
                        <img alt="ko"  height="50" src={toAbsoluteUrl("/media/svg/icons/Layout/Cancelled_cross.svg")}/>
                      ) )}
       
                </label>
              </div>

              <input className="col-md-10" type="text" id="esito" name="esito" disabled
                value={values.esito}
                //onChange= {e => setPiva(e.target.value)}
                //onChange = {this.handlePivaChanged.bind(this)}
                //onBlur={handleInputChange}
              ></input>
          </div>
      </form>
    </div>

    </>
  );
}

export default Form;
